import * as R from 'ramda'
import hostConf from '$config/frontend'

export const bundleWappsVersion = R.reduce(
  (versionMap, { id, version }) => R.assoc(id, version, versionMap),
  {},
)

export const getWappIcon = wappId =>
  `${hostConf.WAPPS_HOST}/wapp/${wappId}/icon.jpg`
